import React from 'react'
import actions from 'redux/actions'
import { useCallback, useMedia } from 'sb-hooks'
import { constants } from 'common/helpers'

import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Modal from 'components/_new/modal/Modal/Modal'
import MobileModal from 'components/_new/modal/MobileModal/MobileModal'
import Overlay from 'components/_new/layout/Overlay/Overlay'
import Headline from 'components/_new/typography/deprecated/Headline/Headline'
import Button from 'components/_new/Button/Button'
import Box from 'components/_new/layout/Box/Box'
import Image from 'components/_new/ui/Image/Image'

import s from './FeedbackErrorModal.scss'
import messages from './messages'

// resolve picture x2
import failImg from './images/fail.png'


const close = () => actions.models.modals.close(constants.modals.cancelSubscription.FeedbackFormFail)

const FeedbackErrorModal = ({ data: { values, onSuccess } }) => {
  const { isMobile } = useMedia()

  const handleClick = useCallback(() => {
    actions.view.cancelSubscriptionPage.sendFeedback(values)
      .then(
        (data) => {
          close()
          if (typeof onSuccess === 'function') {
            onSuccess(data)
          }
        },
        () => {}
      )
  }, [ values, onSuccess ])

  const buttonNode = (
    <Button
      className={s.button}
      size="md"
      color="brand"
      title={messages.tryAgain}
      onClick={handleClick}
    />
  )

  return isMobile ? (
    <MobileModal onClose={close} onBackdropClick={close}>
      <Box alignCenter>
        <Image className={s.bird} {...failImg} />
        <Headline title={messages.title} subTitle={messages.text} size="lg" mutedSubTitle={false} />
        {buttonNode}
      </Box>
    </MobileModal>
  ) : (
    <ModalContainer>
      <Overlay onClick={close} />
      <Modal onClose={close} footerNode={buttonNode}>
        <Image className={s.bird} {...failImg} />
        <Headline title={messages.title} subTitle={messages.text} size="lg" mutedSubTitle={false} />
      </Modal>
    </ModalContainer>
  )
}


export default FeedbackErrorModal
